import axios from 'axios'
import { API_BASE_URL } from '@/lib/constants'
import { useAuthStore } from '@/store/authStore'
import { useUiStore } from '@/store/uiStore'

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  timeout: 30000,
})

apiClient.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

let handlingUnauthorized = false

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = String(error.config?.url ?? '')
      const isAuthEndpoint =
        url.includes('/auth/request-otp') ||
        url.includes('/auth/verify-otp') ||
        url.includes('/auth/logout')

      if (!isAuthEndpoint && !handlingUnauthorized) {
        handlingUnauthorized = true
        const mobile = useAuthStore.getState().user?.mobile ?? ''
        useAuthStore.getState().clearSession()
        useUiStore.getState().setAuthModalContext({
          mobile,
          startAtOtp: Boolean(mobile),
        })
        useUiStore.getState().setAuthModalOpen(true)
        queueMicrotask(() => {
          handlingUnauthorized = false
        })
      }
    }
    return Promise.reject(error)
  },
)

export default apiClient
